var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ValidationObserver',{ref:"observer",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('FormSanciones',{attrs:{"sancion":_vm.sancion}}),_c('b-button',{staticClass:"ml-2",attrs:{"disabled":_vm.loading,"type":"submit"}},[_vm._v("Crear")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }